import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Redirect, withRouter } from 'react-router-dom';
import { TermsAndConditionUtils, EmailUtil } from 'gw-portals-util-js';
import {
    withApplicationPropertyContext
} from 'tdic-components-platform-react';
import { PolicyService } from 'gw-capability-policy';
import { useAuthentication } from 'gw-digital-auth-react';
import { error } from '@jutro/logger';

function getDestination(from, loginPath) {
    if (from === loginPath) {
        return loginPath;
    }
    return from;
}

function RedirectAfterLogin({
    successPath, loginPath, termsPath, setTnCAcceptedStatus, setTermData,
    tncTransactionTypesSubTypes, isAuthorisedUser
}) {
    // retain previous state
    const [wasLoggedIn, updateWasLoggedIn] = useState(false);
    const [isUserVisitedTerms, setUserVisitedTerms] = useState(null);
    const [loading, setLoading] = useState(true);
    const {
        isLoggedIn, authHeader, email, user_name: userName
    } = useAuthentication();

    const getTermsService = (useCallback(() => {
        return PolicyService
            .getTermsAndCondtions()
            .then((data) => {
                return TermsAndConditionUtils
                    .getLatestTermsAndConditionsByPortal(data)
                    .then((latestTerms) => {
                        return latestTerms;
                    });
            }).catch((err) => {
                error(`RedirectAfterLogin - getTermsAndConditions - Unable to get terms and conditions ${JSON.stringify(err)}`);
                return <Redirect to="/app-error" />;
            });
    }, []));
    const checkUserVisitedTerms = (useCallback((version, auth) => {
        if (!_.isEmpty(tncTransactionTypesSubTypes)) {
            const tncType = _.find(tncTransactionTypesSubTypes, { transaction_Type: 'Login' });
            if (_.isNil(tncType)) {
                return null;
            }
            setLoading(true);
            const role = isAuthorisedUser ? 'AuthorisedUser' : 'PolicyHolder';
            const tncSubType = _.find(tncType.transactionSubTypes, { transaction_SubType: role });
            const reqOption = {
                Version: version,
                acceptance: 1,
                Transaction_Type: _.get(tncType, 'id'),
                Transaction_SubTypes: [
                    _.get(tncSubType, 'id')
                ],
                email_Address: EmailUtil.checkEmailValidity(email) ? email : userName
            };
            return PolicyService
                .hasUserAcceptedTnC(reqOption, auth)
                .then((result) => {
                    setLoading(false);
                    return result;
                });
        }
        return null;
    }, [email, isAuthorisedUser, tncTransactionTypesSubTypes, userName]));
    useEffect(() => {
        updateWasLoggedIn(isLoggedIn);
    }, [isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn && !_.isNull(isAuthorisedUser)) {
            getTermsService()
                .then((termsData) => {
                    setTermData(termsData);
                    return checkUserVisitedTerms(termsData.Version, authHeader);
                })
                .then((isTandCVisible) => {
                    setUserVisitedTerms(isTandCVisible);
                    setTnCAcceptedStatus(isTandCVisible);
                    setLoading(false);
                });
        }
    }, [isLoggedIn, getTermsService, checkUserVisitedTerms, setLoading,
        setUserVisitedTerms, authHeader, setTnCAcceptedStatus,
        setTermData, tncTransactionTypesSubTypes, isAuthorisedUser]);

    if (!loading && isLoggedIn && wasLoggedIn
        && !_.isNull(isAuthorisedUser) && !_.isEmpty(tncTransactionTypesSubTypes)) {
        if (!_.isNull(isUserVisitedTerms)) {
            const dest = getDestination(successPath, loginPath);
            if (!isUserVisitedTerms) {
                return (
                    <Redirect to={{
                        pathname: termsPath,
                        state: {
                            successPath: successPath
                        }
                    }}
                    />
                );
            }
            return <Redirect to={{ pathname: dest }} />;
        }
    }
    return null;
}

RedirectAfterLogin.propTypes = {
    successPath: PropTypes.string,
    loginPath: PropTypes.string,
    termsPath: PropTypes.string,
    setTnCAcceptedStatus: PropTypes.func.isRequired,
    setTermData: PropTypes.func.isRequired,
    tncTransactionTypesSubTypes: PropTypes.shape([]).isRequired,
    isAuthorisedUser: PropTypes.bool.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

RedirectAfterLogin.defaultProps = {
    successPath: '/',
    loginPath: '/login-page',
    termsPath: '/terms-and-conditions'
};

export default withRouter(withApplicationPropertyContext(RedirectAfterLogin));
